import { createSelector } from '@reduxjs/toolkit';
import get from 'lodash/get';

import { DEFAULT_LANGUAGE } from 'constants/common';

export const langSelector = createSelector(
  (state) => get(state, 'lang'),
  (langState) => ({
    ...langState,
    selectedLang: langState.selectedLang || DEFAULT_LANGUAGE.id,
  }),
);
